import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { getAllAssignmentsByItem, deleteItemAssignment } from './ItemService';

// import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import List from '@mui/material/List';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Container from 'components/Container';
import ItemManagerAssignmentAdd from './ItemManagerAssignmentAdd';
import ItemUserAssignmentAdd from './ItemUserAssignmentAdd';
import Typography from '@mui/material/Typography';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const ItemAssignmentList = (props): JSX.Element => {
  //const [loading, setLoading] = useState(false);

  const [itemManagerAssignments, setItemManagerAssignments] = useState<any[]>(
    [],
  );
  const [itemUserAssignments, setItemUserAssignments] = useState<any[]>([]);

  const { subscriptionid } = useParams();
  const { itemid } = useParams();

  const { startDate, endDate } = props;

  const navigate = useNavigate();

  useEffect(() => {
    listItemManagerAssignments();
    listItemUserAssignments();
    return () => {
      setItemManagerAssignments([]);
      setItemUserAssignments([]);
    };
  }, [subscriptionid, itemid]);

  function listItemManagerAssignments() {
    setItemManagerAssignments([]);
    getAllAssignmentsByItem(subscriptionid, itemid, 'ROLE_MANAGER')
      .then((response) => {
        setItemManagerAssignments(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }
  function listItemUserAssignments() {
    setItemUserAssignments([]);
    getAllAssignmentsByItem(subscriptionid, itemid, 'ROLE_USER')
      .then((response) => {
        setItemUserAssignments(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  // function addItemAssignment() {
  //   navigate('/add-item');
  // }

  function selectItemAssignment(userid) {
    navigate(
      `/subscription/${subscriptionid}/item/${itemid}/assignment-by-Item/${userid}`,
    );
  }

  function removeItemAssignment(id) {
    deleteItemAssignment(id)
      .then(() => {
        listItemManagerAssignments();
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function removeUserItemAssignment(id) {
    deleteItemAssignment(id)
      .then(() => {
        listItemUserAssignments();
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <Container>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={4}
      >
        <Typography variant="h4">Items</Typography>
      </Box>
      {/* {loading && <p>Loading...</p>} */}

      <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
        Assigned To
      </Typography>
      <ItemManagerAssignmentAdd
        //itemName={itemName}
        startDate={startDate}
        endDate={endDate}
        subscriptionid={subscriptionid}
        listItemManagerAssignments={listItemManagerAssignments}
      />
      <List>
        {itemManagerAssignments.map((itemManagerAssignment) => (
          <ListItem
            key={itemManagerAssignment.name}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            onClick={() => selectItemAssignment(itemManagerAssignment.id)}
          >
            <ListItemAvatar>
              <Avatar>
                <FolderIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText>
              {itemManagerAssignment.firstName} {itemManagerAssignment.lastName}
            </ListItemText>
            <IconButton
              onClick={(event) => {
                event.stopPropagation(); // Stop the click event from propagating
                removeItemAssignment(itemManagerAssignment.id);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </ListItem>
        ))}
      </List>
      <ItemUserAssignmentAdd
        //itemName={itemName}
        startDate={startDate}
        endDate={endDate}
        subscriptionid={subscriptionid}
        listItemUserAssignments={listItemUserAssignments}
      />
      <List>
        {itemUserAssignments.map((itemUserAssignment) => (
          <ListItem
            key={itemUserAssignment.name}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            onClick={() => selectItemAssignment(itemUserAssignment.id)}
          >
            <ListItemAvatar>
              <Avatar>
                <FolderIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText>
              {itemUserAssignment.firstName} {itemUserAssignment.lastName}
            </ListItemText>
            <IconButton
              onClick={(event) => {
                event.stopPropagation(); // Stop the click event from propagating
                removeUserItemAssignment(itemUserAssignment.id);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </ListItem>
        ))}
      </List>
    </Container>
  );
};

export default ItemAssignmentList;
